import React, { FC, LabelHTMLAttributes } from 'react';
import classnames from 'classnames';
import { Error } from 'components';
import styles from './NumberInput.module.scss';
import { t } from 'utils';
export interface NumberInputInterface extends LabelHTMLAttributes<HTMLLabelElement> {
  name: string;
  max?: string;
  min?: string;
  step?: string;
  value: string;
  label: string;
  type?: string;
  error?: any;
  pattern?: string;
  active?: boolean;
  touched?: boolean;
  disabled?: boolean;
  required?: boolean;
  pristine?: boolean;
  errorText?: string;
  onBlur?: () => void;
  onFocus?: () => void;
  currencySymbol?: string;
  errorClassname?: string;
  onChange?: (event: any) => void;
  changeValue?: (name: string, value: any) => void;
  labelVariable?: { variable: string; value: string; translate?: boolean };
  placeholderVariable?: { variable: string; value: string; translate?: boolean };
}

const NumberInput: FC<NumberInputInterface> = (props) => {
  const {
    name,
    value,
    label,
    error,
    active,
    touched,
    pattern,
    disabled,
    required,
    className,
    changeValue,
    // errorText,
    labelVariable,
    currencySymbol,
    type = 'number',
    errorClassname,
    placeholder = '',
    onBlur = () => {},
    onFocus = () => {},
    onChange = () => {},
    placeholderVariable,
  } = props;
  const rootClassName = classnames(styles.root, className, {
    [styles.focused]: active,
    [styles.disabled]: disabled,
    [styles.error]: error && touched,
    [styles.filled]: value && !active,
  });
  let labelText = '';
  if (label || labelVariable) {
    const textToReplace = labelVariable
      ? [
          {
            key: labelVariable.variable,
            value: labelVariable.value,
            translateReplace: labelVariable.translate,
          },
        ]
      : [];
    labelText = t(label, textToReplace);
  }
  let placeholderText;
  if (placeholder || placeholderVariable) {
    const textToReplace = placeholderVariable
      ? [
          {
            key: placeholderVariable.variable,
            value: placeholderVariable.value,
            translateReplace: placeholderVariable.translate,
          },
        ]
      : [];
    placeholderText = t(placeholder, textToReplace);
  }

  return (
    <div className={rootClassName}>
      {label && (
        <label className={styles.label}>
          {labelText}
          {required && ' *'}
        </label>
      )}
      <input
        value={value}
        className={styles.input}
        name={name}
        type={type}
        required={required}
        onWheel={(e) => {
          e.preventDefault(); // stop changing value on scroll // throws console errors - needs to be fixed
        }}
        pattern={pattern}
        onKeyPress={(event) => {
          // discard symbols
          if (['e', ',', '-', '+'].includes(event.key)) event.preventDefault();
        }}
        onChange={onChange}
        onFocus={(e) => {
          if (+value === 0) {
            changeValue?.(name, ''); // comes from final-form -> form?.change
          }
          onFocus();
        }}
        onBlur={onBlur}
        disabled={disabled}
        placeholder={placeholderText}
        autoComplete='off'
      />
      {currencySymbol && <span className={styles.currency}>{currencySymbol}</span>}
      <Error className={classnames('mt-1', errorClassname)} isError={error}>
        {error}
      </Error>
    </div>
  );
};

export default NumberInput;
